(function () {
	'use strict';

    const module = angular.module('imApp');

    module.component('compValidationSet', {
        templateUrl: 'views/components/views/compValidationSet/compValidationSet.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'compValidationSetService', function ($stateParams, stateService, translateService, modalService, compValidationSetService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let compKeyno = $stateParams.comp_keyno;

            let translations = {
                error: '',
                ok: ''
            };

    		vm.model = {
                compValidationFilterButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.setting.compvalidation_filter = '' }
                ],
    			setting: {},
    			itemsListValidations: [],
    			itemsListCombinations: [],
    			lockedSave: false
    		};

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATE SERVICE

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadSetting() {
                vm.model.setting = (await compValidationSetService.getSetting({ comp_keyno: compKeyno }))[0];

                loadValidations();
            }

            async function loadValidations() {
                vm.model.itemsListValidations = (await compValidationSetService.listValidations({ comp_keyno: compKeyno }));

                loadCombinations();
    		}
            
            async function loadCombinations() {
                vm.model.itemsListCombinations = (await compValidationSetService.listCombinations({ records: vm.model.itemsListValidations }));
    		}

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region TOGGLE FUNCTIONS

    		vm.toggleChosenValidations = function (item) {
    			if (item.item_id === '0') return;
    			if (item.item_id === '-1') return;
                
    			if (item.item_is_selected === '0') {
    				item.item_is_selected = '1';
    			} else if (item.item_is_selected === '1') {
    				item.item_is_selected = '0';
    			}
                
    			loadCombinations();
    		};
            
    		vm.toggleChosenCombinations = function (item) {
    			if (item.item_id === '0') return;
    			if (item.item_id === '-1') return;
                
    			if (item.item_is_selected === '0') {
    				item.item_is_selected = '1';
    			} else if (item.item_is_selected === '1') {
    				item.item_is_selected = '0';
    			}
    		};

            // #endregion TOGGLE FUNCTIONS

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                compValidationSetService.saveItems({
                    comp_keyno: compKeyno,
                    records1: vm.model.itemsListValidations,
                    records2: vm.model.itemsListCombinations
                }).then((response) => {
                    if (response[0] && response[0].errorcode !== '0') {
                    	modalService.show({
                    		type: 'warning',
                    		title: translations.error,
                    		message: response[0].errormessage,
                    		buttons: [{
                    			label: translations.ok,
                    			cssClass: 'btn-warning',
                    			action: function (dialogItself) {
                    				dialogItself.close();
                    				vm.model.lockedSave = false;
                    			}
                    		}]
                    	});
                    } else {
                    	vm.model.lockedSave = false;
                    	stateService.back();
                    }
                });
            };

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                translate();
                loadSetting();
            };

            // #endregion ON INIT FUNCTION

    	}]
    });
})();
